<script lang="ts">
	let { lang = 'bash', code }: { lang?: string; code: string } = $props();
</script>

<!-- The terminal stays dark in both themes; colors are pinned, not theme-derived. -->
<div class="group relative my-4 overflow-hidden rounded-xl border border-border bg-[#161618]">
	<div class="flex items-center justify-between border-b border-white/10 px-4 py-2">
		<span class="font-mono text-xs uppercase tracking-widest text-[#98989d]">{lang}</span>
		<div class="flex gap-1.5">
			<span class="h-2.5 w-2.5 rounded-full bg-pill-red/70"></span>
			<span class="h-2.5 w-2.5 rounded-full bg-pill-amber/70"></span>
			<span class="h-2.5 w-2.5 rounded-full bg-pill-green/70"></span>
		</div>
	</div>
	<pre class="tnum overflow-x-auto px-4 py-4 text-sm leading-relaxed text-[#f5f5f7]"><code
			>{code}</code
		></pre>
</div>
